export default "__VITE_ASSET__a82af7ca__"